import { ONE_DAY_IN_MILLISECONDS, UnifiedGroup } from '../../../shared';

export function getExpiryInDays(group: UnifiedGroup): number {
    return group.isExpiring && group.expiryDateTime
        ? Math.floor(
              (group.expiryDateTime.getTime() - new Date().getTime()) / ONE_DAY_IN_MILLISECONDS
          )
        : 0;
}
